import EmrFormItem, { IEmrFormItemProps } from '@/screens/CreateEmr/EmrInput/EmrFormItem';
import { Input, InputProps } from 'antd';
import * as React from 'react';

export interface IEmrInputProps extends Omit<InputProps, 'name'> {
  field?: IFieldConfig;
  name?: string[] | string;
  labelProps?: IEmrFormItemProps;
}

const EmrInput: React.FC<IEmrInputProps> = ({ disabled, field, name, labelProps = {}, ...props }) => {
  return (
    <EmrFormItem field={field} name={name} initialValue={field?.default} {...labelProps} valuePropName="value">
      <Input placeholder={field?.placeholder} className={`base-input`} {...props} disabled={disabled} />
    </EmrFormItem>
  );
};
export default EmrInput;
